




















import { Component, Vue, Prop } from "vue-property-decorator";
import { EventBus } from "../event-bus";

@Component({
  components: {}
})
export default class ErrorModal extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() readonly errorTitle!: string;
  @Prop() readonly errorText!: string;

  get show() {
    return this.value;
  }
  set show(value: boolean) {
    EventBus.$emit("closeErrorModal", value);
  }
}
